<script setup>
import AppLayout from '@/layouts/AppLayout.vue'

defineProps({
  utilisateur: { type: Object, default: () => ({}) },
  can_update:  { type: Boolean, default: false },
})
</script>

<template>
  <AppLayout>
    <template #topbar-left>
      <div class="text-xs font-black uppercase tracking-widest text-outline">
        Utilisateurs &rsaquo; {{ utilisateur.email }}
      </div>
    </template>

    <div class="p-8">
      <div class="max-w-4xl mx-auto">

        <!-- Page Header -->
        <div class="mb-8 flex justify-between items-end">
          <div>
            <h1 class="text-3xl font-black text-on-surface tracking-tight uppercase">
              {{ utilisateur.nom }} {{ utilisateur.prenom }}
            </h1>
            <p class="text-outline text-sm font-black uppercase tracking-widest mt-1">
              {{ utilisateur.email }}
            </p>
          </div>
          <div class="flex items-center gap-3">
            <a
              v-if="can_update"
              :href="`/utilisateurs/${utilisateur.id}/edit`"
              class="flex items-center gap-2 px-4 py-2 text-xs font-black uppercase tracking-widest text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 rounded-md transition-all"
            >
              <span class="material-symbols-outlined text-base">edit</span>
              Modifier
            </a>
            <a
              href="/utilisateurs"
              class="flex items-center gap-2 px-4 py-2 text-xs font-black uppercase tracking-widest text-outline hover:text-on-surface bg-surface-container-low border border-outline-variant/10 rounded-md transition-all"
            >
              <span class="material-symbols-outlined text-base">arrow_back</span>
              Retour
            </a>
          </div>
        </div>

        <!-- Detail Card -->
        <div class="bg-surface-container rounded-xl border-l-4 border-primary shadow-2xl shadow-black/40 overflow-hidden">
          <div class="divide-y divide-outline-variant/10">

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Courriel</span>
              <span class="text-sm text-on-surface font-medium">{{ utilisateur.email }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Nom</span>
              <span class="text-sm text-on-surface">{{ utilisateur.nom || '—' }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Prénom</span>
              <span class="text-sm text-on-surface">{{ utilisateur.prenom || '—' }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Rôle</span>
              <span class="text-sm text-on-surface font-bold">{{ utilisateur.role_nom || '—' }}</span>
            </div>

            <div class="flex items-center px-8 py-4 gap-6">
              <span class="text-[10px] font-black uppercase tracking-widest text-outline w-40 shrink-0">Statut</span>
              <span
                :class="utilisateur.actif
                  ? 'bg-tertiary/15 text-tertiary border border-tertiary/30'
                  : 'bg-outline/10 text-outline border border-outline/20'"
                class="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-black uppercase tracking-widest"
              >
                <span class="w-1.5 h-1.5 rounded-full" :class="utilisateur.actif ? 'bg-tertiary' : 'bg-outline/50'"></span>
                {{ utilisateur.actif ? 'Actif' : 'Inactif' }}
              </span>
            </div>

          </div>
        </div>

        <!-- Footer -->
        <footer class="mt-12 pb-6 text-center text-outline text-[10px] uppercase tracking-widest font-black">
          Copyright &copy; 2016-{{ new Date().getFullYear() }} aurapport.com inc.
        </footer>

      </div>
    </div>
  </AppLayout>
</template>
